"use client";

import { ArticleGlanceCard, Typography } from "@aph/ui-lib-humanx";
import React from "react";
import sliderStyles from "@/components/Slider/Slider.module.scss";
import Slider, { Slide } from "@/components/Slider";
import { DeviceInfo } from "@/interface/deviceInfo";
import { useAppSelector } from "@/redux/hooks";
import DeviceSelector from "@/components/ArticlePage/redux/selectors/userAgent";
import IconRight from "$/icons/icon-right.svg";
import IconLeft from "$/icons/icon-left.svg";
import styles from "./ArticleGlance.module.scss";

interface ArticleGlanceProps {
  title?: string;
  GlanceList?: [];
  className?: string;
}

const ArticleGlance: React.FC<ArticleGlanceProps> = (props) => {
  const { title, className = "", GlanceList } = props;

  const deviceType: DeviceInfo = useAppSelector(DeviceSelector);

  return (
    <div className={`${styles.articleRoot} ${className}`}>
      <div className={styles.topSection}>
        {title && (
          <Typography component="h2" className={styles.title}>
            {title}
          </Typography>
        )}
        <div className={`${styles.slidercontainer}`}>
          <Slider
            autoplay={false}
            showArrows={deviceType?.isDesktop}
            dotsWrapperClass={sliderStyles.dotsWrapperClass}
            dotClass={sliderStyles.dotClass}
            dotClassActive={sliderStyles.dotClassActive}
            slidesToShow={deviceType?.isDesktop ? 2 : 1.5}
            columnGap={15}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {GlanceList?.length > 0 &&
              GlanceList.map((glance: any, index: number) => (
                <Slide key={glance.id} index={index} className={styles.sliderRoot}>
                  <ArticleGlanceCard
                    {...{
                      title: glance?.Title,
                      subTitle: glance?.Description,
                      backgroundColor: index % 2 === 0 ? "#D7DFFF" : "#FA6631",
                      textColor: index % 2 === 0 ? "#222222" : "#FFFFFF",
                    }}
                  />
                </Slide>
              ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ArticleGlance;
